var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column mt-4"},[_c('div',{staticClass:"caution-title"},[_vm._v("注意事項")]),_c('div',{staticClass:"caution-text text-start py-2 px-3"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }